<template>
  <div v-if="hasData" class="filter-container scrollbar" ref="scrollComponent" @scroll="handleScroll"
    :class="{ 'filter-container--open': filterStore.filterPanelOpen, 'filter-container--collapsed': !filterStore.filterPanelOpen }">

    <div class="filters" :class="{ 'filters--scrollable': filterStore.showAdvancedFilter }">
      <div class="filters__header">
        <h2 class="filter-component-heading">Filtrering</h2>
        <button class="filters__close-button button button--pop button--filter"
          v-if="filterStore.filterPanelOpen" aria-label="Stäng filter" @click="toggleFilterPanel">
          <span class="icon icon--close"></span>
        </button>
      </div>


      <ClearButton v-if="filterStore.activeFilters.length > 0 || filterStore.activeSearchFilters.length > 0"
        class="filters__clear" @click="clearFilters" />

      <Search />
      <SimpleFilter />
      <AdvancedFilter />
    </div>
    <button class="filter-toggle button button--pop button--filter"
      :class="{ 'filter-toggle--panel-open': filterStore.filterPanelOpen }" :aria-expanded="filterStore.filterPanelOpen"
      :aria-label="filterToggleAriaLabel" @click="toggleFilterPanel">
      <span class="filter-toggle__leading-icon icon icon--horizontal-slider"></span>
      <span class="filter-toggle__label">{{ filterToggleLabel }}</span>
      <span class="filter-toggle__trailing-icon icon"
        :class="filterStore.filterPanelOpen ? `icon--arrow-left` : `icon--arrow-right`"></span>
    </button>
  </div>
</template>
<script setup lang="ts">
import { computed, onMounted, onUnmounted } from 'vue';
import AdvancedFilter from '@/components/filter/AdvancedFilter.vue';
import ClearButton from '@/components/clear/ClearButton.vue';
import Search from '@/components/search/Search.vue';
import SimpleFilter from '@/components/filter/SimpleFilter.vue';
import { useFilterStore } from "../../stores/filterStore";
import { useStore } from '../../stores/store';
import { useQuery } from '@/services/query-service';

const FILTER_PANEL_MOBILE_BREAKPOINT = 992;

const store = useStore();
const filterStore = useFilterStore();
const { clearQueryParameters } = useQuery();
let filterPanelMediaQuery: MediaQueryList | null = null;
const handleFilterPanelBreakpointChange = (event: MediaQueryListEvent) => {
  syncFilterPanelWithViewport(event.matches);
};

const hasData = computed(() => store.originalSearchResult?.results.length > 0);
const filterToggleLabel = computed(() => filterStore.filterPanelOpen ? `Visa ${store.numTotalResult} resultat` : 'Filter');
const filterToggleAriaLabel = computed(() => filterStore.filterPanelOpen ? filterToggleLabel.value : 'Visa filter');

const syncFilterPanelWithViewport = (matchesMobileViewport: boolean) => {
  filterStore.filterPanelOpen = !matchesMobileViewport;
};

const toggleFilterPanel = () => {
  filterStore.filterPanelOpen = !filterStore.filterPanelOpen;
}

const clearFilters = () => {
  filterStore.activeFilters.splice(0, filterStore.activeFilters.length);
  filterStore.activeSearchFilters.splice(0, filterStore.activeSearchFilters.length);
  store.sorting.descending = true;
  store.sorting.dataKey = null;
  store.searchResult = store.originalSearchResult;
  clearQueryParameters();
}

onMounted(() => {
  filterPanelMediaQuery = window.matchMedia(`(max-width: ${FILTER_PANEL_MOBILE_BREAKPOINT}px)`);
  syncFilterPanelWithViewport(filterPanelMediaQuery.matches);
  filterPanelMediaQuery.addEventListener('change', handleFilterPanelBreakpointChange);
});

onUnmounted(() => {
  filterPanelMediaQuery?.removeEventListener('change', handleFilterPanelBreakpointChange);
});
</script>
